import { Component, OnInit } from '@angular/core';
import { ParametrizacaoService } from '@modules/parametrizacao/services/parametrizacao.service';
import { IvasaoCompletaObject, IvasaoPorCidadeObject } from '@modules/visitas/services/models';
import * as toastr from 'toastr'

@Component({
  selector: 'app-invasao-setor-por-cidade',
  templateUrl: './invasao-setor-por-cidade.component.html',
  styleUrls: ['./invasao-setor-por-cidade.component.css']
})
export class InvasaoSetorPorCidadeComponent implements OnInit {

  fzsInvasor = "";
  fzsVago = "";
  qtdMeses = "";
  cidadesSelecionadas = "";

  isLoading = false;

  isSAC = true;

  // cidades: string[] = ['Belford roxo', 'Nova Iguaçu', 'São João de Meriti'];

  cidades = [
    // { id: 1, nome: 'Belford roxo', selecionado: false },
    // { id: 2, nome: 'Nova Iguaçu', selecionado: false },
    // { id: 3, nome: 'São João de Meriti', selecionado: false },
    // Adicione mais itens conforme necessário
  ];

  constructor(private parametrizacaoService: ParametrizacaoService) { }

  ngOnInit() {
  }

  saveInvasao(){

    this.cidadesSelecionadas = "";

    console.log(this.fzsInvasor, "fzsInvasor");
    console.log(this.fzsVago, "fzsVago");
    console.log(this.qtdMeses, "qtdMeses");

    if(this.fzsInvasor == ""){
      toastr.error('Campo "FZS Invasor" é obrigatório');
      return;
    }

    if(this.fzsVago == ""){
      toastr.error('Campo "FZS Vago" é obrigatório');
      return;
    }

    if(this.qtdMeses == ""){
      toastr.error('A Combo "Período" é obrigatório');
      return;
    }

    const selecionados = this.cidades.filter(item => item.selecionado);
    console.log('Itens selecionados:', selecionados);

    if(selecionados.length == 0){
      toastr.error('Selecione as cidades que serão invadidas');
      return;
    }

    selecionados.forEach((cidade) => {
      this.cidadesSelecionadas = this.cidadesSelecionadas + cidade.id + ",";
    });

    let filtro = {
      invasor: this.fzsInvasor,
      vago: this.fzsVago,
      qtd: this.qtdMeses,
      ids: this.cidadesSelecionadas.substring(0,this.cidadesSelecionadas.length-1),
    }

    const params: IvasaoPorCidadeObject = {
      fzsInvasor: filtro.invasor,
      fzsVago: filtro.vago,
      qtdMeses: filtro.qtd,
      idsCidade: filtro.ids.substring(0,filtro.ids.length-1)
    }

    console.log(params)
    // typeof(params.yearMounthEnd);

    this.parametrizacaoService.saveInvasaoPorCidade(filtro).subscribe(
        resp=> {
                toastr.success("Invasão salva")
              },
        error => {
                toastr.error("Error ao salvar Invasão")
              }
    )

  }

  removeInvasao(){

    this.cidadesSelecionadas = "";

    console.log(this.fzsInvasor, "fzsInvasor");
    console.log(this.fzsVago, "fzsVago");
    console.log(this.qtdMeses, "qtdMeses");

    if(this.fzsInvasor == ""){
      toastr.error('Campo "FZS Invasor" é obrigatório');
      return;
    }

    if(this.fzsVago == ""){
      toastr.error('Campo "FZS Vago" é obrigatório');
      return;
    }

    const selecionados = this.cidades.filter(item => item.selecionado);
    console.log('Itens selecionados:', selecionados);

    if(selecionados.length == 0){
      toastr.error('Não há cidades selecionadas para remover invasão!');
      return;
    }

    selecionados.forEach((cidade) => {
      this.cidadesSelecionadas = this.cidadesSelecionadas + cidade.id + ",";
    });

    let filtro = {
      invasor: this.fzsInvasor,
      vago: this.fzsVago,
      qtd: this.qtdMeses,
      ids: this.cidadesSelecionadas.substring(0,this.cidadesSelecionadas.length-1),
    }

    const params: IvasaoPorCidadeObject = {
      fzsInvasor: filtro.invasor,
      fzsVago: filtro.vago,
      qtdMeses: filtro.qtd,
      idsCidade: filtro.ids.substring(0,filtro.ids.length-1)
    }

    console.log(params)
    // typeof(params.yearMounthEnd);

    this.parametrizacaoService.removeInvasaoPorCidade(filtro).subscribe(
        resp=> {
                toastr.success("Remoção salva");
                this.getCidades();
              },
        error => {
                toastr.error("Error ao remover invasão")
              }
    )

  }

  // Função chamada quando um checkbox é alterado
  alterarSelecao(item: any) {
    // if(!item.selecionado){
    //   item.selecionado = true;
    // }
    // else{
    //   item.selecionado = false;
    // }
    // item.selecionado = !item.selecionado;
  }

  getCidades(){

    if(this.fzsVago != ""){

      if(this.fzsVago.length == 6){
        this.parametrizacaoService.getCidades(this.fzsVago, this.fzsInvasor).subscribe(
          data => {
            this.cidades = data;
            // this.vendedorLoading = false;
        },
          error => console.log(error)
        );
      }
    }
  }

}
